import api from '../lib/api';
import type { Paginated } from '../types';
import type { ClientManagerTarget, ClientManagerTargetInput } from '../types/crm';

// Single-record endpoints (show/create/update) return a JSON:API-style envelope:
// `{ data: { id, type, attributes: {...flat record...} } }`. List endpoints return
// flat records directly inside `data`. Mirrors operator.service.ts.

export const clientManagerTargetService = {
  getAll: async (
    params?: Record<string, unknown>
  ): Promise<Paginated<ClientManagerTarget>> => {
    const response = await api.get<Paginated<ClientManagerTarget>>('/client_manager_targets', {
      params,
    });
    return response.data;
  },

  getById: async (id: number): Promise<ClientManagerTarget> => {
    const response = await api.get<{ data: { attributes: ClientManagerTarget } }>(
      `/client_manager_targets/${id}`
    );
    return response.data.data.attributes;
  },

  create: async (data: ClientManagerTargetInput): Promise<ClientManagerTarget> => {
    const response = await api.post<{ data: { attributes: ClientManagerTarget } }>(
      '/client_manager_targets',
      { client_manager_target: data }
    );
    return response.data.data.attributes;
  },

  update: async (
    id: number,
    data: Partial<ClientManagerTargetInput>
  ): Promise<ClientManagerTarget> => {
    const response = await api.patch<{ data: { attributes: ClientManagerTarget } }>(
      `/client_manager_targets/${id}`,
      { client_manager_target: data }
    );
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/client_manager_targets/${id}`);
  },
};

export default clientManagerTargetService;
